import { component } from 'picoapp';
import animateValue from '../utils/animate';

export default component(async (node) => {
  const {
    apiKey,
    spreadsheetId,
    currency,
    currencySuffix,
    range,
  } = JSON.parse(node.querySelector('[data-config]').textContent);

  const fetchData = async () => {
    if (!apiKey || !spreadsheetId || !range) {
      throw new Error('Missing config elements');
    }

    const url = new URL(`https://sheets.googleapis.com/v4/spreadsheets/${spreadsheetId}/values/${Object.values(range).join(':')}`);
    url.searchParams.append('key', apiKey);

    try {
      const response = await fetch(url.toString());
      const data = await response.json();

      return data.values[0];
    } catch (error) {
      throw new Error(error);
    }
  };

  const clamp = (num, min, max) => Math.min(Math.max(num, min), max);

  const init = async () => {
    const [current, total] = await fetchData();
    const currentValue = parseInt(current, 10);
    const totalValue = parseInt(total, 10);

    const percentage = (currentValue / totalValue) * 100;
    const progressPercentage = clamp(percentage, 0, 100);

    const progressElement = node.querySelector('[data-progress]');
    const currentElement = progressElement.querySelector('[data-progress-current]');
    const goalElement = node.querySelector('[data-progress-goal]');

    const progressCountElement = node.querySelector('[data-progress-count]');
    const progressNumberElement = progressCountElement.querySelector('[data-progress-number]');

    if (progressPercentage < 25) {
      currentElement.classList.add('right-aligned');
    }

    if (progressPercentage < 5) {
      currentElement.classList.add('extra-offset');
    }

    document.addEventListener('readystatechange', () => {
      if (document.readyState === 'complete') {
        animateValue(currentElement, 0, current, 4000, 'money', currency, currencySuffix);
        animateValue(progressNumberElement, 0, progressPercentage, 4000);

        goalElement.textContent = Shopify.formatMoney(
          totalValue * 100,
          theme.moneyFormat,
        ).toString().replace(currency, currencySuffix);

        goalElement.style.opacity = progressPercentage > 85 ? '0' : '100';

        progressCountElement.style.opacity = '100';
        const distance = progressPercentage < 1 ? 9 : 13;
        progressCountElement.style.left = `calc(${progressPercentage}% - ${distance}px)`;

        progressElement.style.setProperty('--tw-translate-x', `${progressPercentage - 100}%`);
      }
    });
  };

  init();
});
